export default function inactivePorDealsReducer(
  state = {
    data: [],
    fetching: false,
    fetched: false,
  },
  action
) {
  switch (action.type) {
    case 'GET_INACTIVE_POR_DEALS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case 'GET_INACTIVE_POR_DEALS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payLoad.data
      };
    }
    case 'GET_INACTIVE_POR_DEALS_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors,
      };
    }
    case 'CLEAR_INACTIVE_POR_DEALS': {
      return {
        ...state,
        data: []
      };
    }
    default:
  }

  return { ...state };
}



// WEBPACK FOOTER //
// ./src/reducers/inactivePorDealsReducer.js